import axios from "axios";
import { API_URL } from "../constants/config";

const CUSTOMERS_BASE = `${API_URL}/api/customers`;

const buildParams = (params = {}) => {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    usp.set(key, value);
  });
  const qs = usp.toString();
  return qs ? `?${qs}` : "";
};

// Single entry point for all customer list fetches.
// No params → bare array (full list for joins/dropdowns).
// With { page, limit, ... } → paginated envelope { customers, pagination }.
export const fetchCustomersList = async (params = {}) => {
  const response = await axios.get(`${CUSTOMERS_BASE}${buildParams(params)}`);
  return response.data;
};

export const fetchCustomer = async (customerId) => {
  const response = await axios.get(`${CUSTOMERS_BASE}/${customerId}`);
  return response.data;
};

export const createCustomer = async (newCustomer) => {
  const response = await axios.post(CUSTOMERS_BASE, newCustomer);
  return response.data;
};

export const updateCustomer = async (customerId, updatedCustomer) => {
  const response = await axios.put(
    `${CUSTOMERS_BASE}/${customerId}`,
    updatedCustomer
  );
  return response.data;
};

export const deleteCustomer = async (customerId) => {
  const response = await axios.delete(`${CUSTOMERS_BASE}/${customerId}`);
  return response.data;
};
